import React, { useState } from "react";
import styles from "../FilterSearchList.module.css";
import { CustomButton } from "../../../buttons";
import { translate } from "../../../../providers";
import { InfiniteList2 } from "../../../infinite-list";
import FilterSearchRow from "../filter-search-row/FilterSearchRow";

const FilterInfiniteList = ({
	filterKey = "",
	initChecked = [],
	onChangeSearch,
	onClear,
	onClickRow,
	request,
	rowLabelKey,
	rowKey = rowLabelKey,
	rowSecondaryLabelKey = "",
	searchResultCount = null,
	searchPlaceholder,
}) => {
	const [checkedElements, setCheckedElements] = useState(initChecked);
	const handleClear = () => {
		setCheckedElements([]);
		onClear();
	};
	const isRowChecked = ({ [rowKey]: identifier }) => checkedElements.some((element) => element === identifier);
	const handleClick = (row) => {
		let newCheckedElements = [];
		const { [rowKey]: identifier } = row;
		if (checkedElements.some((element) => element === identifier)) {
			newCheckedElements = checkedElements.filter((element) => element !== identifier);
		} else {
			newCheckedElements = [...checkedElements, identifier];
		}
		setCheckedElements(newCheckedElements);
		onClickRow(newCheckedElements, filterKey);
	};
	const rowRenderer = (row) => (
		<FilterSearchRow
			key={row[rowKey]}
			ancestors={[]}
			checkedElements={checkedElements}
			hasChildren={row.children && row.children.length > 0}
			isRowChecked={isRowChecked}
			label={row[rowLabelKey]}
			row={row}
			rowKey={rowKey}
			rowLabelKey={rowLabelKey}
			secondaryLabel={row[rowSecondaryLabelKey]}
			onClick={handleClick}
		/>
	);
	return (
		<div className={styles.filter}>
			<div className={styles.filter__options}>
				{onClear && (
					<CustomButton
						className={styles.options__clear}
						color="primary"
						size="md"
						variant="text"
						onClick={handleClear}
					>
						{translate("common:btn.clear-select")}
					</CustomButton>
				)}
				{onChangeSearch && (searchResultCount || searchResultCount === 0) && (
					<span className={styles.options__results}>
						{translate(searchResultCount > 1 ? "common:results" : "common:result", {
							count: searchResultCount,
						})}
					</span>
				)}
			</div>
			<InfiniteList2
				hasSearch
				className={styles.test}
				request={request}
				rowRenderer={rowRenderer}
				searchPlaceholder={searchPlaceholder}
			/>
		</div>
	);
};

export default FilterInfiniteList;
